// src/host/utils/debug-tools.util.ts
import { fetchAuthSession } from 'aws-amplify/auth';
import { GlobalSocketService } from '@host/services/socket.service';
import { GlobalEventService } from '@host/services/event.service';
import { voLogger } from '@shared/utils/logger';
const log = voLogger('entry');

const ENABLE_DEBUG = import.meta.env.VITE_APP_DEBUG_TOOLS === 'true';

export const registerDebugTools = () => {
  if (!ENABLE_DEBUG) return;

  window.__VO = {
    GES: GlobalEventService,
    GSS: GlobalSocketService,
    getAuthToken: async () => {
      const session = await fetchAuthSession();
      return session.tokens?.accessToken?.toString() ?? null;
    },
    getIdToken: async () => {
      const session = await fetchAuthSession();
      return session.tokens?.idToken?.toString() ?? null;
    },
  };

  log(' window.__NEXGEN_DEBUG__ loaded (VITE_DEBUG_TOOLS=true)');
};

// Types
declare global {
  interface Window {
    __VO?: Record<string, any>;
  }
}
